<template>
  <section class="pc-panel pc-basic-info">
    <header class="pc-panel__head">
      <span class="pc-panel__bar"></span>
      <h2 class="pc-panel__title">基本信息</h2>
    </header>

    <div class="pc-basic-info__body">
      <div class="pc-basic-info__avatar">
        <el-upload
          class="avatar-uploader"
          :action="uploadAction"
          :show-file-list="false"
          name="file"
          accept="image/png, image/jpeg"
          :on-success="handleAvatarSuccess"
        >
          <img
            v-if="user.selfImage"
            class="avatar-uploader__img"
            :src="apiBase + user.selfImage"
          />
          <img
            v-else
            class="avatar-uploader__img"
            :src="defaultAvatar"
            style="width: 100px; height: 100px; padding: 20px"
            alt=""
          />
          <i class="el-icon-camera avatar-uploader__camera"></i>
        </el-upload>
      </div>

      <div class="pc-basic-info__msg">
        <li style="max-width: 100px"><i class="el-icon-s-custom"></i>用户名</li>
        <li>{{ displayName }}</li>
        <p @click="openNameDialog">修改</p>
      </div>
      <div class="pc-basic-info__msg">
        <li style="max-width: 100px">
          <i class="iconfont icon-shouji01"></i>手机号码
        </li>
        <li>{{ displayPhone }}</li>

        <p @click="openPhoneDialog">更换</p>
      </div>
      <div class="pc-basic-info__msg">
        <li style="max-width: 100px">
          <i class="iconfont icon-mima"></i>登录密码
        </li>
        <li>******</li>

        <p @click="openPwdDialog">修改</p>
      </div>
      <div class="pc-basic-info__msg">
        <li style="max-width: 100px">
          <i class="iconfont icon-zhanghaozhuxiao"></i>账号注销
        </li>
        <li></li>
        <p @click="cancelAccount">注销</p>
      </div>
    </div>

    <!-- 更换手机号 -->
    <FormDialog
      :visible="phoneShow"
      title="更换手机号"
      :width="520"
      @close="closePhoneDialog"
    >
      <el-form
        ref="phoneForm"
        :model="phoneForm"
        :rules="phoneRules"
        label-width="100px"
        label-position="right"
        @submit.native.prevent
      >
        <el-form-item label="手机号" prop="phone">
          <div class="pc-basic-info-pop__field">
            <img class="input-icon" src="@/assets/images/login/sj.png" alt="" />
            <el-input
              v-model="phoneForm.phone"
              placeholder="请输入未注册的手机号"
              clearable
              maxlength="11"
            />
          </div>
        </el-form-item>
        <el-form-item label="图形验证码" prop="imgcode">
          <div
            class="pc-basic-info-pop__field pc-basic-info-pop__field--captcha"
          >
            <img
              class="input-icon"
              src="@/assets/images/login/yzm.png"
              alt=""
            />
            <el-input
              v-model="phoneForm.imgcode"
              maxlength="4"
              placeholder="请输入图形验证码"
            />
            <p class="identify-wrap" @click="refreshCode">
              <Sidentify
                :identifyCode="identifyCode"
                :content-height="30"
                :font-size-min="16"
                :font-size-max="22"
              />
            </p>
          </div>
        </el-form-item>
        <el-form-item label="短信验证码" prop="msgcode">
          <div class="pc-basic-info-pop__field pc-basic-info-pop__field--sms">
            <img class="input-icon" src="@/assets/images/login/dx.png" alt="" />
            <el-input
              v-model="phoneForm.msgcode"
              maxlength="10"
              placeholder="请输入短信验证码"
            />
            <span v-if="smsReady" class="sms-btn" @click="sendSmsCode"
              >获取短信验证码</span
            >
            <span v-else class="sms-btn is-disabled"
              >重新发送({{ smsCountdown }})</span
            >
          </div>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button
          class="indiv-btn"
          type="primary"
          size="small"
          :loading="phoneSubmitting"
          @click="submitPhone"
        >
          确定
        </el-button>
      </template>
    </FormDialog>

    <!-- 修改密码 -->
    <FormDialog
      :visible="pwdShow"
      title="修改密码"
      :width="480"
      @close="closePwdDialog"
    >
      <el-form
        ref="pwdForm"
        :model="pwdForm"
        :rules="pwdRules"
        label-width="80px"
        label-position="right"
        @submit.native.prevent
      >
        <el-form-item label="原密码" prop="oldPwd">
          <el-input
            v-model="pwdForm.oldPwd"
            placeholder="原密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="pwdForm.newPwd"
            placeholder="新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input
            v-model="pwdForm.confirmPwd"
            placeholder="确认密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button
          class="indiv-btn"
          type="primary"
          size="small"
          :loading="pwdSubmitting"
          @click="submitPwd"
        >
          确定
        </el-button>
      </template>
    </FormDialog>

    <!-- 修改用户名 -->
    <FormDialog
      :visible="nameShow"
      title="修改用户名"
      :width="480"
      @close="closeNameDialog"
    >
      <el-form
        ref="nameForm"
        :model="nameForm"
        :rules="nameRules"
        label-width="90px"
        label-position="right"
        @submit.native.prevent
      >
        <el-form-item label="当前用户名">
          <el-input placeholder="当前用户名" :value="displayName" disabled />
        </el-form-item>
        <el-form-item label="新用户名" prop="newName">
          <el-input
            v-model="nameForm.newName"
            placeholder="请输入新用户名"
            maxlength="20"
            clearable
          />
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button
          class="indiv-btn"
          type="primary"
          size="small"
          :loading="nameSubmitting"
          @click="submitName"
        >
          确定
        </el-button>
      </template>
    </FormDialog>

    <!-- 账号注销确认 -->
    <AccountCancelDialog
      :visible.sync="logoutDialogVisible"
      redirect-url="/client/terminal-download?from=indiv"
      @close="closeLogoutDialog"
    />
  </section>
</template>

<script>
/** 基本信息：头像、手机号、密码、用户名、账号注销 */
import Sidentify from "@/components/register/sidentify/index";
import AccountCancelDialog from "@/components/accountCancelDialog/AccountCancelDialog.vue";
import defaultAvatar from "../../img/avatar.png";
import {
  userAccountState,
  refreshUserAccount,
} from "@/view/user/userAccount/userAccountService";

const IDENTIFY_CHARS = "abcdefghijklmnopqrstuvwxyz123456789";

const EMPTY_PHONE_FORM = {
  phone: "",
  imgcode: "",
  msgcode: "",
};

const EMPTY_PWD_FORM = {
  oldPwd: "",
  newPwd: "",
  confirmPwd: "",
};

const EMPTY_NAME_FORM = {
  newName: "",
};

export default {
  name: "PcBasicInfo",
  components: { Sidentify, AccountCancelDialog },
  data() {
    return {
      defaultAvatar,
      user: userAccountState.profile ? { ...userAccountState.profile } : {},
      phoneShow: false,
      pwdShow: false,
      nameShow: false,
      phoneForm: { ...EMPTY_PHONE_FORM },
      pwdForm: { ...EMPTY_PWD_FORM },
      nameForm: { ...EMPTY_NAME_FORM },
      identifyCode: "",
      smsReady: true,
      smsCountdown: 60,
      smsTimer: null,
      phoneSubmitting: false,
      pwdSubmitting: false,
      nameSubmitting: false,
      logoutDialogVisible: false,
    };
  },
  computed: {
    apiBase() {
      return this.$store.state.api;
    },
    apiToken() {
      return this.$store.state.usermsg.apiToken;
    },
    uploadAction() {
      return `${this.apiBase}/ad/upload/upload_file`;
    },
    displayName() {
      return this.$store.state.usermsg.name || "";
    },
    /** 页面展示手机号，中间 4 位脱敏 */
    displayPhone() {
      const u = this.$store.state.usermsg;
      const phone = u.phone || u.mobile || u.mob || "";
      const str = String(phone).trim();
      if (/^1\d{10}$/.test(str)) {
        return `${str.slice(0, 3)}****${str.slice(7)}`;
      }
      return str;
    },
    /** 更换手机号表单校验 */
    phoneRules() {
      return {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: ["blur", "change"],
          },
        ],
        imgcode: [
          { validator: this.validateImgcode, trigger: ["blur", "change"] },
        ],
        msgcode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    /** 修改密码表单校验 */
    pwdRules() {
      return {
        oldPwd: [
          {
            required: true,
            message: "原密码不可为空",
            trigger: ["blur", "change"],
          },
        ],
        newPwd: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"],
          },
        ],
        confirmPwd: [
          {
            required: true,
            message: "请确认密码",
            trigger: ["blur", "change"],
          },
          { validator: this.validateConfirmPwd, trigger: ["blur", "change"] },
        ],
      };
    },
    /** 修改用户名表单校验 */
    nameRules() {
      return {
        newName: [
          {
            required: true,
            message: "请输入新用户名",
            trigger: ["blur", "change"],
          },
          { validator: this.validateNewName, trigger: ["blur", "change"] },
        ],
      };
    },
  },
  mounted() {
    this.refreshCode();
    this.fetchUserInfo();
  },
  beforeDestroy() {
    this.clearSmsTimer();
  },
  methods: {
    /** 拉取用户基本信息，优先读 indiv 会话缓存 */
    fetchUserInfo(force = false) {
      refreshUserAccount({
        force,
        store: this.$store,
      }).then((profile) => {
        if (profile) {
          this.user = profile;
        }
      });
    },
    handleAvatarSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.message);
        return;
      }
      this.$request
        .post("/cloud/user_account/change_self_image", {
          SelfImage: res.data.filePath,
        })
        .then(() => {
          this.fetchUserInfo(true);
        });
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      let code = "";
      for (let i = 0; i < 4; i += 1) {
        code += IDENTIFY_CHARS[this.randomNum(0, IDENTIFY_CHARS.length)];
      }
      this.identifyCode = code;
    },
    /** 图形验证码校验 */
    validateImgcode(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入图形验证码"));
        return;
      }
      if (value !== this.identifyCode) {
        callback(new Error("图片验证码错误"));
        return;
      }
      callback();
    },
    /** 确认密码与新密码一致 */
    validateConfirmPwd(rule, value, callback) {
      if (!value) {
        callback(new Error("请确认密码"));
        return;
      }
      if (value !== this.pwdForm.newPwd) {
        callback(new Error("两次密码输入不一致"));
        return;
      }
      callback();
    },
    /** 新用户名不可与当前相同 */
    validateNewName(rule, value, callback) {
      const trimmed = String(value || "").trim();
      if (!trimmed) {
        callback(new Error("请输入新用户名"));
        return;
      }
      if (trimmed === this.displayName) {
        callback(new Error("新用户名与当前用户名相同"));
        return;
      }
      if (trimmed.length > 20) {
        callback(new Error("用户名最多20个字符"));
        return;
      }
      callback();
    },
    clearFormValidate(refName) {
      this.$nextTick(() => {
        const form = this.$refs[refName];
        if (form) form.clearValidate();
      });
    },
    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    },
    startSmsCountdown() {
      this.smsReady = false;
      this.smsCountdown = 60;
      this.clearSmsTimer();
      this.smsTimer = setInterval(() => {
        this.smsCountdown -= 1;
        if (this.smsCountdown <= 0) {
          this.clearSmsTimer();
          this.smsReady = true;
          this.smsCountdown = 60;
        }
      }, 1000);
    },
    resetPhoneForm() {
      this.phoneForm = { ...EMPTY_PHONE_FORM };
      this.phoneSubmitting = false;
    },
    resetPwdForm() {
      this.pwdForm = { ...EMPTY_PWD_FORM };
      this.pwdSubmitting = false;
    },
    resetNameForm() {
      this.nameForm = { ...EMPTY_NAME_FORM };
      this.nameSubmitting = false;
    },
    openPhoneDialog() {
      this.resetPhoneForm();
      this.refreshCode();
      this.phoneShow = true;
      this.clearFormValidate("phoneForm");
    },
    closePhoneDialog() {
      this.phoneShow = false;
      this.resetPhoneForm();
    },
    openPwdDialog() {
      this.resetPwdForm();
      this.pwdShow = true;
      this.clearFormValidate("pwdForm");
    },
    closePwdDialog() {
      this.pwdShow = false;
      this.resetPwdForm();
    },
    openNameDialog() {
      this.resetNameForm();
      this.nameShow = true;
      this.clearFormValidate("nameForm");
    },
    closeNameDialog() {
      this.nameShow = false;
      this.resetNameForm();
    },
    /** 发送短信验证码（先校验手机号） */
    sendSmsCode() {
      const form = this.$refs.phoneForm;
      if (!form) return;
      form.validateField("phone", (error) => {
        if (error) return;
        const { phone } = this.phoneForm;
        this.$request
          .post(
            "/user_login_api/sms_code",
            { type: 2, phone },
            { skipToken: true, rawResponse: true }
          )
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code === 200) {
              this.startSmsCountdown();
            } else {
              this.$message.error(res.data.message);
            }
          });
      });
    },
    /** 提交更换手机号 */
    submitPhone() {
      const form = this.$refs.phoneForm;
      if (!form || this.phoneSubmitting) return;
      form.validate((valid) => {
        if (!valid) return;
        const { phone, msgcode } = this.phoneForm;
        this.phoneSubmitting = true;
        this.$request
          .post(
            "/cloud/user_account/change_phone",
            {
              mob: phone,
              verifyCode: msgcode,
            },
            { rawResponse: true }
          )
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code === 200) {
              const u = this.$store.state.usermsg;
              u.phone = phone;
              u.mob = phone;
              u.mobile = phone;
              try {
                localStorage.setItem("token", JSON.stringify(u));
              } catch (e) {
                /* ignore */
              }
              this.closePhoneDialog();
              this.$alert("修改成功", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              });
            } else {
              this.$message.error(res.data.message);
            }
          })
          .finally(() => {
            this.phoneSubmitting = false;
          });
      });
    },
    /** 提交修改密码 */
    submitPwd() {
      const form = this.$refs.pwdForm;
      if (!form || this.pwdSubmitting) return;
      form.validate((valid) => {
        if (!valid) return;
        const { oldPwd, newPwd, confirmPwd } = this.pwdForm;
        this.pwdSubmitting = true;
        this.$request({
          method: "post",
          url: "/cloud/user_account/chagne_pwd",
          params: {
            oldPwd,
            newPwd1: newPwd,
            newPwd2: confirmPwd,
          },
          tokenInParams: true,
          rawResponse: true,
        })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code === 200) {
              this.closePwdDialog();
              this.$alert("修改成功", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              });
            } else {
              this.$message.error(res.data.message);
            }
          })
          .finally(() => {
            this.pwdSubmitting = false;
          });
      });
    },
    /** 提交修改用户名 */
    submitName() {
      const form = this.$refs.nameForm;
      if (!form || this.nameSubmitting) return;
      form.validate((valid) => {
        if (!valid) return;
        const trimmed = String(this.nameForm.newName || "").trim();
        this.nameSubmitting = true;
        this.$request
          .post(
            "/cloud/user_account/change_name",
            {
              name: trimmed,
            },
            { rawResponse: true }
          )
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code === 200) {
              const tipName =
                (res.data.data && res.data.data.name) ||
                res.data.name ||
                trimmed;
              this.$store.state.usermsg.name = tipName;
              try {
                localStorage.setItem(
                  "token",
                  JSON.stringify(this.$store.state.usermsg)
                );
              } catch (e) {
                /* ignore */
              }
              this.$alert("修改成功", {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              });
              this.closeNameDialog();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .finally(() => {
            this.nameSubmitting = false;
          });
      });
    },
    /** 账号注销确认 */
    cancelAccount() {
      this.logoutDialogVisible = true;
    },
    closeLogoutDialog() {
      this.logoutDialogVisible = false;
    },
  },
};
</script>

<style scoped src="./style.css"></style>

<style scoped>
.pc-basic-info__body {
  padding-top: 4px;
}

.pc-basic-info__avatar {
  position: relative;
  width: 140px;
  margin-bottom: 20px;
}

.avatar-uploader {
  position: relative;
  display: block;
}

.avatar-uploader__img {
  width: 140px;
  height: 140px;
  border-radius: 4px;
  object-fit: cover;
  border: 2px solid #dce6f6;
}

.avatar-uploader__placeholder {
  display: block;
  width: 140px;
  height: 140px;
  line-height: 140px;
  color: #dcdfe6;
  text-align: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}

.avatar-uploader__camera {
  position: absolute;
  right: -15px;
  bottom: 0;
  display: block;
  width: 28px;
  height: 28px;
  font-size: 17px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  background-color: #5b85ff;
  border: 1px solid #fff;
  border-radius: 50%;
}

.pc-basic-info__msg {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 50px;
  margin: 0 auto 19px;
  padding: 10px 20px;
  background-color: #fff;
  border: 1px solid #eceff2;
}

.pc-basic-info__msg:hover {
  border-color: #7195ff;
}

.pc-basic-info__msg li {
  width: 150px;
  height: 30px;
  margin-right: 30px;
  font-size: 14px;
  line-height: 30px;
  list-style: none;
  flex: 1;
}

.pc-basic-info__msg li i {
  margin-right: 15px;
  font-size: 16px;
  color: #8997ab;
}

.pc-basic-info__msg p {
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  color: #7195ff;
  text-align: right;
  cursor: pointer;
}

/* 弹窗输入框：左侧图标 + 右侧验证码/按钮 */
.pc-basic-info-pop__field {
  position: relative;
}

.pc-basic-info-pop__field >>> .el-input {
  width: 340px;
  max-width: 100%;
}

.pc-basic-info-pop__field >>> .el-input__inner {
  height: 32px;
  padding-left: 45px;
  line-height: 32px;
}

.pc-basic-info-pop__field--captcha >>> .el-input__inner {
  padding-right: 108px;
}

.pc-basic-info-pop__field--sms >>> .el-input__inner {
  padding-right: 118px;
}

.pc-basic-info-pop__field .input-icon {
  position: absolute;
  top: 50%;
  left: 20px;
  z-index: 10;
  width: 13px;
  transform: translateY(-50%);
}

.pc-basic-info-pop__field .identify-wrap {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  align-items: center;
  width: 100px;
  height: 34px;
  margin: 0;
  overflow: hidden;
  cursor: pointer;
  transform: translateY(-50%);
}

.pc-basic-info-pop__field .identify-wrap >>> canvas {
  display: block;
  width: 100px;
  height: 31px;
}

.pc-basic-info-pop__field .sms-btn {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 14px;
  color: var(--indiv-color-primary, #5b85ff);
  white-space: nowrap;
  cursor: pointer;
  transform: translateY(-50%);
}

.pc-basic-info-pop__field .sms-btn.is-disabled {
  cursor: default;
}
</style>




// WEBPACK FOOTER //
// src/view/client/personal-center/panels/BasicInfo/index.vue